import { useParams } from 'react-router-dom';

import TasksOverview from '../../features/tasks/layouts/overview';
import TasksBoard from '../../features/tasks/layouts/board';
import TaskDetail from '../../features/tasks/layouts/detail';
import CreateTaskForm from '../../features/tasks/forms/create';
import EditTaskForm from '../../features/tasks/forms/edit';
import CommitTrace from '../../features/tasks/layouts/trace';

// TSS vite/01 §"Pages are thin" — read the URL, mount a feature.
//
// READING AND EDITING ARE TWO ROUTES, because they are two permissions. The
// backend has always had `tasks:read` and `tasks:write` as separate codes;
// this page used to answer /admin/tasks/:id with the edit form, so the route
// had to be guarded by :write and anybody who could only read the work could
// not open a single task.

export default function TasksPage({ mode }) {
    const { id } = useParams();

    if (mode === 'trace') return <CommitTrace />;
    if (mode === 'create' || id === 'new') return <CreateTaskForm />;
    if (mode === 'list') return <TasksOverview />;
    if (mode === 'edit' && id) return <EditTaskForm taskId={id} />;
    if (id) return <TaskDetail taskId={id} />;

    // The board is what /admin/tasks answers. The work of a project is read by
    // looking at what is pending, moving and done — the list is the same data
    // for when a column is not enough.
    return <TasksBoard />;
}
